import { Fragment, useState, useEffect, useRef } from 'react'

import { Checkbox, Dialog, DialogBackdrop, DialogPanel, DialogTitle, Field, Input, Label } from '@headlessui/react'
import { PhoneArrowDownLeftIcon } from '@heroicons/react/24/outline'

import { CheckIcon } from '@heroicons/react/16/solid'


import { useLocation, useNavigate, Link } from "react-router-dom";
import Button from './Button';
import clsx from 'clsx';
import { handle_enter_keydown, sleep } from '../libs/helpers';
import { validate_phone_number } from '../libs/validate';
import { ExclamationTriangleIcon, PhoneArrowDownLeftIcon as PhoneArrowDownLeftIconSolid } from '@heroicons/react/20/solid';
import ReactLoading from 'react-loading';
import axios from 'axios';
import { coordinator_map } from '../libs/formats';



const DemoModal = ({
  is_open,
  set_is_open,
  demo_is_active,
  set_demo_is_active,
  journey,
  set_refresh_variable,
  coordinator,
} : {
  is_open : boolean,
  set_is_open : any, // todo
  demo_is_active : boolean,
  set_demo_is_active : any, // todo
  journey : any, // todo
  set_refresh_variable : any // todo
  coordinator : any // todo
}) => {



  // Navigate
  const navigate = useNavigate()

  // Location
  const location = useLocation()

  // Status
  const [is_awaiting, set_is_awaiting] = useState(false)


  // Page
  const [page, set_page] = useState(0)

  // User input
  const [phone_number, set_phone_number] = useState("")
  const [first_name, set_first_name] = useState("")

  // Demo phone number
  const [demo_phone_number, set_demo_phone_number] = useState("")

  // Refs
  const phone_number_ref = useRef<any>(null);
  const first_name_ref = useRef<any>(null);

  // Status messages
  const [error_message, set_error_message] = useState("")

  // One time token
  const [one_time_token_id, set_one_time_token_id] = useState("")


  // Handle user input
  const handle_user_input = (type, value) => {
    switch(type) {
      case "phone_number": {

        let val = value

        // Trim any non numeric characters
        val = val.replace(/\D/g, "")

        // Trim anything beyond 10 characters
        val = val.slice(0, 10)

        set_phone_number(`+1${val}`)
  
        // Always break
        break
      }
      case "first_name": {
        set_first_name(value)
  
        // Always break
        break
      }
      default: {

        // Always break
        break
      }
    }

    // Always hide error message and reset it to empty string
    set_error_message("")
  }

  const submit = async () => {
    
    // Reset error message
    set_error_message("")

    // Set is_fetched to false
    set_is_awaiting(true)

    switch (page) {
      case 0: {
        // START OF USER INPUT CHECK
    
        // Validate phone number
        if (phone_number.length === 0) {
          set_is_awaiting(false)

          // Show error message
          set_error_message("Please enter your phone number")

          // End of the line
          return
        }

        if (phone_number.length !== 12) {
          set_is_awaiting(false)

          // Show error message
          set_error_message("US phone numbers must be 10 digits long")

          // End of the line
          return
        }

        if (!validate_phone_number(phone_number)) {
          set_is_awaiting(false)

          // Show error message
          set_error_message("Please enter a valid phone number")

          // End of the line
          return
        }

        // Validate name
        if (!first_name) {
          set_is_awaiting(false)

          // Show error message
          set_error_message("Please enter your name")

          // End of the line
          return
        }

        // END OF USER INPUT CHECK

        const post_demo_initiate_res = await axios.post(`https://app.vitalstrata.com/api/demo/initiate`, {
          coordinator: coordinator,
          phone_number: phone_number,
          first_name: first_name,
        })

        if (!post_demo_initiate_res.data.success) {
          switch (post_demo_initiate_res.data.status) {
            case "FATAL_ERROR": {
              alert("Fatal error")
              
              // Always break
              break
            }
            default: {
              alert("An error occured. Please try again.")

              // Always break
              break
            }
          }

          set_is_awaiting(false)

          return
        }

        switch (post_demo_initiate_res.data.status) {
          case "SUCCESS": {
            set_is_awaiting(false)

            // Save demo phone number
            set_demo_phone_number(post_demo_initiate_res.data.demo_phone_number)

            // Move onto next page
            set_page(1)

            // // Start polling
            // start_polling()

            // Always break
            break
          }
          case "_____": {
            // _____

            // Always break
            break
          }
          default: {
            set_is_awaiting(false)
            set_error_message("An unexpected error occurred. Please try again.")
            break
          }
        }

        

        // Always break
        break
      }
      default: {
        // Always break
        break
      }
    }
  }

  const start_polling = async () => {
    let status = "ready"; // "ready", "active", "terminated"
    let polling_interval: NodeJS.Timeout | null = null;

    try {
      // MAKE SURE THE POLLING STOPS WHEN CALL IS NOT ACTIVE
      while (status === "ready" || status === "active") {
        // Execute get latest one_time_token
        const get_one_time_token_res = await axios.get(`https://app.vitalstrata.com/api/one-time-tokens/${one_time_token_id}`);

        // Handle server error
        if (!get_one_time_token_res.data.success) {
          status = "terminated";
          set_error_message("Failed to check call status. Please try again.");
          set_demo_is_active(false);
          break;
        }

        // Check call_is_in_progress
        if (status === "ready" && get_one_time_token_res.data.one_time_token?.token_metadata?.call_is_in_progress) {
          status = "active";
          set_demo_is_active(true);
        }

        if (status === "active" && !get_one_time_token_res.data.one_time_token) {
          status = "terminated";
          set_demo_is_active(false);
          set_is_open(false);
          break;
        }

        // Delay
        await sleep(4.0);
      }
    } catch (error) {
      console.error("Polling error:", error);
      status = "terminated";
      set_demo_is_active(false);
      set_error_message("An error occurred while checking call status.");
    } finally {
      // Cleanup
      if (polling_interval) {
        clearInterval(polling_interval);
      }
      set_demo_is_active(false);
      set_page(0);
    }
  };

  // Renders  
  useEffect(() => {

  }, [])

  // When opened
  useEffect(() => {

    if (is_open) {
      setTimeout(() => {
        first_name_ref.current.focus()
      }, 100)      
    }

  }, [is_open])

  return (
    <Dialog open={is_open} onClose={set_is_open} className="relative z-20">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        // className="fixed inset-0 fixed-backdrop transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-sm sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >

            {/* Top Icon */}
            <div className="mx-auto flex size-12 items-center justify-center rounded-full bg-green-100">
              {/* <CheckIcon aria-hidden="true" className="size-6 text-green-600" /> */}
              <PhoneArrowDownLeftIcon aria-hidden="true" className="size-6 text-green-600" />
            </div>

            {/* Content area */}
            <div>
              {(() => {
                switch(page) {
                  case 0: {
                    return (
                      <>
                        {/* Title */}
                        <div className="mt-3 text-center sm:mt-5">
                          <DialogTitle as="h3" className="text-base font-semibold text-gray-900">
                            Try a live call with {coordinator_map[coordinator]}
                          </DialogTitle>
                        </div>

                        {/* Text */}
                        <div className="mt-3 text-center sm:mt-5">
                          <div className="mt-2">
                            <p className="text-sm text-gray-900">
                              Enter your first name and phone number to try the live demo.
                            </p>
                          </div>
                        </div>

                        {/* First name input */}
                        <div className="mt-3">
                          <input
                            type="text"
                            className={clsx(
                              'block w-full rounded-lg border border-transparent shadow ring-1 ring-black/10',
                              'text-gray-900',
                              'focus:outline focus:outline-2 focus:-outline-offset-1 focus:outline-black',
                              "text-2xl sm:text-sm px-2.5 py-2.5 sm:py-1.5"
                            )} 
                            // className="block w-full rounded-md border-0 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6 text-2xl py-2.5 sm:py-1.5"
                            placeholder="Marie"
                            value={first_name}
                            onChange={(e) => handle_user_input("first_name", e.target.value)}
                            disabled={is_awaiting} 
                            ref={first_name_ref}
                          />
                        </div>

                        {/* Phone number input */}
                        <div className="mt-3 text-center sm:mt-5">
                          <div className="flex items-center">
                            <button  
                              // className="flex-shrink-0 inline-flex items-center py-2.5 px-4 text-sm font-medium text-center text-gray-900 border border-gray-300 rounded-s-md hover:bg-gray-100 focus:ring-1 focus:outline-none focus:ring-gray-100" 
                              className={clsx(
                                'flex-shrink-0 inline-flex items-center border border-transparent shadow ring-1 ring-black/10 rounded-s-lg',
                                'text-gray-900',
                                'focus:outline focus:outline-2 focus:-outline-offset-1 focus:outline-black focus:z-50',
                                'hover:bg-gray-100',
                                "text-2xl sm:text-sm px-2.5 py-2.5 sm:py-1.5"
                              )} 
                              // className="flex-shrink-0 inline-flex items-center px-4 sm:text-sm font-medium text-center text-gray-900 border border-gray-300 rounded-s-md hover:bg-gray-100 focus:ring-1 focus:outline-none focus:ring-gray-100 sm:leading-6 text-2xl py-2.5 sm:py-1.5"
                            >
                              <svg fill="none" aria-hidden="true" className="h-4 w-4 me-2" viewBox="0 0 20 15"><rect width="19.6" height="14" y=".5" fill="#fff" rx="2"/><mask id="a" width="20" height="15" x="0" y="0" maskUnits="userSpaceOnUse"><rect width="19.6" height="14" y=".5" fill="#fff" rx="2"/></mask><g mask="url(#a)"><path fill="#D02F44" fillRule="evenodd" d="M19.6.5H0v.933h19.6V.5zm0 1.867H0V3.3h19.6v-.933zM0 4.233h19.6v.934H0v-.934zM19.6 6.1H0v.933h19.6V6.1zM0 7.967h19.6V8.9H0v-.933zm19.6 1.866H0v.934h19.6v-.934zM0 11.7h19.6v.933H0V11.7zm19.6 1.867H0v.933h19.6v-.933z" clipRule="evenodd"/><path fill="#46467F" d="M0 .5h8.4v6.533H0z"/><g filter="url(#filter0_d_343_121520)"><path fill="url(#paint0_linear_343_121520)" fillRule="evenodd" d="M1.867 1.9a.467.467 0 11-.934 0 .467.467 0 01.934 0zm1.866 0a.467.467 0 11-.933 0 .467.467 0 01.933 0zm1.4.467a.467.467 0 100-.934.467.467 0 000 .934zM7.467 1.9a.467.467 0 11-.934 0 .467.467 0 01.934 0zM2.333 3.3a.467.467 0 100-.933.467.467 0 000 .933zm2.334-.467a.467.467 0 11-.934 0 .467.467 0 01.934 0zm1.4.467a.467.467 0 100-.933.467.467 0 000 .933zm1.4.467a.467.467 0 11-.934 0 .467.467 0 01.934 0zm-2.334.466a.467.467 0 100-.933.467.467 0 000 .933zm-1.4-.466a.467.467 0 11-.933 0 .467.467 0 01.933 0zM1.4 4.233a.467.467 0 100-.933.467.467 0 000 .933zm1.4.467a.467.467 0 11-.933 0 .467.467 0 01.933 0zm1.4.467a.467.467 0 100-.934.467.467 0 000 .934zM6.533 4.7a.467.467 0 11-.933 0 .467.467 0 01.933 0zM7 6.1a.467.467 0 100-.933.467.467 0 000 .933zm-1.4-.467a.467.467 0 11-.933 0 .467.467 0 01.933 0zM3.267 6.1a.467.467 0 100-.933.467.467 0 000 .933zm-1.4-.467a.467.467 0 11-.934 0 .467.467 0 01.934 0z" clipRule="evenodd"/></g></g><defs><linearGradient id="paint0_linear_343_121520" x1=".933" x2=".933" y1="1.433" y2="6.1" gradientUnits="userSpaceOnUse"><stop stopColor="#fff"/><stop offset="1" stopColor="#F0F0F0"/></linearGradient><filter id="filter0_d_343_121520" width="6.533" height="5.667" x=".933" y="1.433" colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse"><feFlood floodOpacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="1"/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_343_121520"/><feBlend in="SourceGraphic" in2="effect1_dropShadow_343_121520" result="shape"/></filter></defs></svg>
                              <span>+1</span> 
                            </button>

                            <div className="relative w-full">
                              <input 
                                type="tel"  
                                // className="block p-2.5 w-full z-20 text-sm text-gray-900 rounded-s-none rounded-e-lg border-s-0 border border-gray-300 focus:ring-blue-600 focus:border-blue-500 placeholder:text-gray-400" 
                                className={clsx(
                                  'block w-full rounded-s-none rounded-e-lg border border-transparent shadow ring-1 ring-black/10',
                                  'text-gray-900',
                                  'focus:outline focus:outline-2 focus:-outline-offset-1 focus:outline-black',
                                  "text-2xl sm:text-sm px-2.5 py-2.5 sm:py-1.5"
                                )} 
                                // className="block px-2.5 w-full z-20 sm:text-sm text-gray-900 rounded-e-md border-s-0 border border-gray-300 focus:ring-blue-600 focus:border-blue-600 placeholder:text-gray-400 sm:leading-6 text-2xl py-2.5 sm:py-1.5"
                                pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}" 
                                placeholder="123-456-7890" 
                                value={(() => {
                                  // Slice "+1"
                                  let val = phone_number.slice(2)
                                  
                                  // Add hyphens as appropriate
                                  if (val.length > 3 && val.length <= 6) {
                                    val = `${val.slice(0, 3)}-${val.slice(3)}`;
                                  } else if (val.length > 6) {
                                    val = `${val.slice(0, 3)}-${val.slice(3, 6)}-${val.slice(6, 10)}`;
                                  }

                                  return val
                                })()} 
                                onChange={(e) => handle_user_input("phone_number", e.target.value)}
                                onKeyDown={(e) => handle_enter_keydown(e, submit)}
                                disabled={is_awaiting} 
                                ref={phone_number_ref}
                              />
                            </div>
                          </div>
                        </div>

                      </>
                    )
                  }
                  case 1: {
                    return (
                      <>
                        {/* Title */}
                        <div className="mt-3 text-center sm:mt-5">
                          <DialogTitle as="h3" className="text-base font-semibold text-gray-900">
                            {`In a moment, ${coordinator_map[coordinator]} will call you from this number.`} 
                          </DialogTitle>
                        </div>

                        {/* Text */}
                        <div className="mt-5 flex justify-center group cursor-pointer">
                          <div 
                            // to={`tel:${demo_phone_number}`}
                            className={clsx(
                              "text-lg font-bold text-gray-900 flex items-center space-x-2",
                              "px-4 py-[calc(theme(spacing.2)-1px)] rounded-full border border-transparent bg-white/15 shadow-md ring-1 ring-[#000000]/15 hover:bg-black/10"
                            )}
                          >
                            <PhoneArrowDownLeftIconSolid aria-hidden="true" className="size-5 " />
                            <div>
                              {(() => {
                                // Slice "+1"
                                let val = demo_phone_number.slice(2)
                                
                                // Format
                                val = `(${val.slice(0, 3)}) ${val.slice(3, 6)}-${val.slice(6, 10)}`;

                                return val
                              })()}
                            </div>
                          </div>
                        </div>

                      </>
                    )
                  }
                  default : {
                    return <></>
                  }
                }

              })()}
            </div>

            {/* Error message */}
            {error_message
            ? <div className="mt-4 flex space-x-2 items-start">
                <ExclamationTriangleIcon className="pt-[2px] h-4 w-4 min-w-4 min-h-4 text-red-400 h-full"/>
                <div className="text-sm font-base text-red-400">{error_message}</div>
              </div>
            : <></>}

            {/* Button */}
            <div className="mt-5 sm:mt-6 flex justify-center">
              <Button 
                onClick={page === 0 ? submit : null} 
                className="w-full"
              >
                {!is_awaiting ? (
                  <>
                    {/* Text */}
                    {(() => {
                      switch(page) {
                        case 0: return `Receive call from ${coordinator_map[coordinator]}`
                        case 1: return `Demo in progress`
                        default: return `Continue`
                      }
                    })()}

                    {/* Loading wheel */}
                    {page === 1 ? (
                      <div className="ml-2">
                        <ReactLoading
                          type='spokes'
                          color='#FFFFFF'
                          height={20}
                          width={20}
                        />
                      </div>
                    ) : (<></>)}
                  </>
                ) : (
                  // Loading wheel
                  <ReactLoading
                    type='spokes'
                    color='#FFFFFF'
                    height={20}
                    width={20}
                  />
                )}
                
              </Button>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  )
}

export default DemoModal;
